import React from 'react';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import TabComponents from '@/pages/intelligence/components/TabComponents';
// import { IMetricList } from '@/pages/intelligence/pages/GenreProfile/typings';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import MetricSpecialProgress from './MetricSpecialProgress';
import { financeFormat } from '@home/utils/common';

// valueType为hashMark，环比值为整数
const getGrowth = ({ value, valueType }: { value: number | string; valueType: string; }) => {
  if (!value) return '-';
  if (valueType === 'hashMark') return value?.toString();
  if (value === -1 || value === 1) return '100%';
  const _value = Math.abs(Number(value) * 100);
  // if (_value > 9999) return '9999+%';
  return `${_value.toString().includes('.') ? _value.toFixed(2) : _value}%`;
};

const getType = (value: number | string) => {
  if (!value) return '';
  if (value === '-' || value === '=') return '';
  return Number(value) > 0 ? 'up' : 'down';
};

const getDodHide = ({ str, ratioHideCol }: { str: string; ratioHideCol: string[]; }) =>
  ratioHideCol?.includes(str);

// valueType为hashMark，值要加#
const getValue = ({ value, valueType }: { value: number | string; valueType: string }) => {
  // if (!valueType || valueType === 'normal') return valueFormat(value);
  if (!valueType || valueType === 'normal') return financeFormat(value, 2, false, '-');
  if (valueType === 'hashMark') return !value ? '-' : `#${value}`;
  return valueFormat(value);
};

const getElContent = ({
  value,
  valueType,
  ratio,
  metricName,
  ratioHideCol,
  type,
}: {
  value: number | string;
  valueType: string;
  ratio: number;
  metricName: string;
  ratioHideCol: string[];
  type: 'default' | 'percent' | 'noGrowth';
}) =>
  !type || type === 'default' || type === 'noGrowth' ? (
    <TableShowData
      value={getValue({ value, valueType })}
      type={getType(ratio)}
      growth={getGrowth({ value: ratio, valueType })}
      isDodHide={type === 'noGrowth' ? true : getDodHide({ str: metricName, ratioHideCol })}
      maxNumber={'none'}
    />
  ) : (
    <MetricSpecialProgress percent={value} />
  );

export default function MetricColContent(props: any) {
  const { metricName, config, context, keyMap, ratioHideCol = [], textBubble } = props;

  const { valueType, align, childWidth = 170, childAlign = 'right', type } = config;
  const value = context[keyMap.metricValue];
  const ratio = context[keyMap.metricRatio];

  return (
    <div className="dbi-insights-table-flex" key={metricName}>
      {align === 'center' ? (
        <CloumsCenter
          width={childWidth}
          // style={{ marginLeft: '-40px' }}
          align={childAlign}
        >
          {getElContent({ value, valueType, ratio, metricName, ratioHideCol, type })}
        </CloumsCenter>
      ) : (
        getElContent({ value, valueType, ratio, metricName, ratioHideCol, type })
      )}
      {textBubble?.text ? <TabComponents data={textBubble} /> : ''}
    </div>
  );
}
